import { getRiskScoreBackgroundColorClassName } from './risk-sets/riskAssessmentSetUtils'

export type HazardRiskScoreProps = {
  score: number
  /** Compact circle (list cards); default matches hazard detail card. */
  variant?: 'default' | 'compact'
}

export function HazardRiskScore({
  score,
  variant = 'default',
}: HazardRiskScoreProps) {
  const backgroundColorClassName = getRiskScoreBackgroundColorClassName(score)
  if (variant === 'compact') {
    return (
      <div className='flex items-center justify-center'>
        <div
          className={`flex size-8 items-center justify-center rounded-full text-sm font-bold text-primary-foreground ${backgroundColorClassName}`}
        >
          {score}
        </div>
      </div>
    )
  }
  return (
    <div className='flex items-center justify-center text-lg'>
      <div
        className={`flex size-10 items-center justify-center rounded-full text-primary-foreground ${backgroundColorClassName}`}
      >
        {score}
      </div>
    </div>
  )
}
